<template>
  <div class="background">
    <ul class="circles">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
  </div>
</template>

<script>
export default {
  name:'background-fast'
};
</script>

<style scoped>
.background {
  position: fixed;
  z-index: -1;
  top: 0;
  left: 0;
}

.background {
  background: #4e54c8;
  background: -webkit-linear-gradient(to left, #8f94fb, #4e54c8);
  width: 100%;
  height: 100vh;
}

.circles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.circles li {
  position: absolute;
  display: block;
  list-style: none;
  width: 20px;
  height: 20px;
  background: rgba(255, 255, 255, 0.2);
  animation: animate 5s linear infinite;
  bottom: -150px;
}

.circles li:nth-child(1) {
  left: 25%;
  width: 80px;
  height: 80px;
  animation-delay: 0s;
 animation-duration: 2s;
}

.circles li:nth-child(2) {
  left: 10%;
  width: 20px;
  height: 20px;
  animation-delay: 2s;
  animation-duration: 2s;
}

.circles li:nth-child(3) {
  left: 70%;
  width: 20px;
  height: 20px;
  animation-delay: 4s;
  animation-duration: 4s;
}

.circles li:nth-child(4) {
  left: 40%;
  width: 60px;
  height: 60px;
  animation-delay: 0s;
  animation-duration: 3s;
}

.circles li:nth-child(5) {
  left: 65%;
  width: 20px;
  height: 20px;
  animation-delay: 0s;
}

.circles li:nth-child(6) {
  left: 75%;
  width: 110px;
  height: 110px;
  animation-delay: 3s;
}

.circles li:nth-child(7) {
  left: 35%;
  width: 150px;
  height: 150px;
  animation-delay: 2s;
}

.circles li:nth-child(8) {
  left: 50%;
  width: 25px;
  height: 25px;
  animation-delay: 15s;
  animation-duration: 5s;
}

.circles li:nth-child(9) {
  left: 20%;
  width: 35px;
  height: 35px;
  animation-delay: 2s;
  animation-duration: 3s;
}

.circles li:nth-child(10) {
  left: 85%;
  width: 150px;
  height: 150px;
  animation-delay: 0s;
  animation-duration: 4s;
}
.circles li:nth-child(11) {
  left: 50%;
  width: 100px;
  height: 100px;
  animation-delay: 0s;
  animation-duration: 2s;
}
.circles li:nth-child(12) {
  left: 95%;
  width: 30px;
  height: 30px;
  animation-delay: 0s;
  animation-duration: 2s;
}
.circles li:nth-child(13) {
  left: 65%;
  width: 20px;
  height: 20px;
  animation-delay: 0s;
  animation-duration: 1s;
}
.circles li:nth-child(14) {
  left: 15%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
  animation-duration: 5s;
}
.circles li:nth-child(15) {
  left: 5%;
  width: 10px;
  height: 10px;
  animation-delay: 0s;
  animation-duration: 1s;
}
.circles li:nth-child(16) {
  left: 55%;
  width: 80px;
  height: 80px;
  animation-delay: 0s;
  animation-duration: 4s;
}
.circles li:nth-child(17) {
  left: 70%;
  width: 30px;
  height: 30px;
  animation-delay: 0s;
  animation-duration: 5s;
}
.circles li:nth-child(18) {
  left: 35%;
  width: 10px;
  height: 10px;
  animation-delay: 0s;
  animation-duration: 0s;
}


@keyframes animate {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
    border-radius: 0;
  }

  100% {
    transform: translateY(-1000px) rotate(720deg);
    opacity: 0;
    border-radius: 50%;
  }
}
</style>
